import React from 'react';
import AdminSupport from './AdminSupport';
import PatientDoctorSupport from './PatientDoctorSupport';

const Support = () => {
    const userRole = localStorage.getItem('Role') || 'patient';

    // Route to appropriate support component based on role
    if (userRole === 'admin') {
        return (
            <div data-testid="support-router-admin" className="contents">
                <AdminSupport />
            </div>
        );
    } else {
        return (
            <div data-testid="support-router-patient-doctor" className="contents">
                <PatientDoctorSupport />
            </div>
        );
    }
};

export default Support;
